import { render, staticRenderFns } from "./SuggestOverview.vue?vue&type=template&id=237881f3&scoped=true"
import script from "./SuggestOverview.vue?vue&type=script&lang=js"
export * from "./SuggestOverview.vue?vue&type=script&lang=js"
import style0 from "./SuggestOverview.vue?vue&type=style&index=0&id=237881f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237881f3",
  null
  
)

export default component.exports